import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { AsyncPipe, CurrencyPipe, DatePipe } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCell, MatCellDef, MatFooterCell, MatFooterCellDef, MatFooterRow, MatFooterRowDef, MatHeaderCell, MatHeaderCellDef, MatHeaderRow, MatHeaderRowDef, MatRow, MatRowDef, MatTableModule } from '@angular/material/table';
import { Observable } from 'rxjs';
import { Pricelist } from '../../../../pricelists/pricelists.models';
import { env } from '../../../../../env/env';

@Component({
    selector: 'pricelist-details-dialog',
    templateUrl: 'pricelist-details-dialog.html',
    styleUrl: 'pricelist-details-dialog.css',
    imports: [
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        MatTableModule,
        MatRow,
        MatHeaderRow,
        MatFooterRow,
        MatHeaderCellDef,
        MatHeaderRowDef,
        MatFooterRowDef,
        MatRowDef,
        MatCellDef,
        MatFooterCellDef,
        MatCell,
        MatHeaderCell,
        MatFooterCell,
        AsyncPipe,
        DatePipe,
        CurrencyPipe
    ]
})
export class PricelistDetailsDialog implements OnInit {
    constructor(
        private httpClient: HttpClient,
        private dialogRef: MatDialogRef<PricelistDetailsDialog>,
        @Inject(MAT_DIALOG_DATA) public data: { clientId: string, pricelistId: string }) {
    }

    public pricelist$: Observable<Pricelist> | null = null;

    ngOnInit() {
        this.pricelist$ = this.httpClient.get<Pricelist>(`${env.apiUrl}/clients/${this.data.clientId}/pricelists/${this.data.pricelistId}`);
    }

    public isActive(pricelist: Pricelist): boolean {
        const now = new Date();
        return new Date(pricelist.validFrom) <= now && (!pricelist.validTo || new Date(pricelist.validTo) > now);
    }

    public editPricelist(): void {
        this.dialogRef.close('edit');
    }

    public deletePricelist(): void {
        const confirmed = window.confirm('Czy na pewno chcesz usunąć ten cennik? Operacja jest nieodwracalna.');
        if (!confirmed) return;

        this.httpClient.delete(`${env.apiUrl}/clients/${this.data.clientId}/pricelists/${this.data.pricelistId}`).subscribe({
            next: () => this.dialogRef.close(true),
            error: (err) => {
                alert(err?.error ?? 'Błąd podczas usuwania');
            }
        });
    }
}
